import React from 'react';
import { Button, Typography } from '@guildeducationinc/recess';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { APPLICATIONS_ONE_FRONT_DOOR_URL } from '@src/utilities/envConfig';
import styles from './OneFrontDoorNoResultsPlaceholder.module.scss';

export const OneFrontDoorNoResultsPlaceholder: React.FC = () => {
	const { userFromIdToken: user } = useMemberExperienceAuth();

	return (
		<div className={styles.oneFrontDoorNoResultsPlaceholder} data-testid='search-placeholder'>
			<Typography variant='h4'>
				We can&apos;t find programs in Guild&apos;s catalog that match your search
			</Typography>
			<Typography gutterTop='sm' variant='body1'>
				Looking for a specific program or school? If {user.employer || 'your employer'} covers it,
				you can apply for funding today.
			</Typography>
			<Button
				appearance='outline'
				className={styles.oneFrontDoorNoResultsButton}
				href={APPLICATIONS_ONE_FRONT_DOOR_URL}
			>
				Check your benefit
			</Button>
		</div>
	);
};
